import React from "react";
import ComcastCode from "./ComcastCode";
import { getModel } from "../../utils/models";

const GenericSalesCard = ({ children, salesCTAText, salesPhone }) => {
    return (
        <div className="sales-card">
            <div className="sales-card-title">Don't have EverPass?</div>
            <div className="sales-card-content">
                <div>Get access to exclusive games and top</div>
                <div>sports content like NFL Sunday Ticket,</div>
                <div>Peacock Sports Pass and more!</div>
            </div>
            <div className="horizontal-separator"></div>
            <div className="sales-card-footer">
                <div>
                    <div>{salesCTAText}</div>
                    <div>
                        <span className="span-semi-bold">{salesPhone}</span> to get started
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
};

const SalesCard = ({ salesCTAText, salesPhone, coBrandedLogo }) => {
    const model = getModel();

    switch (model) {
        case "xumo":
            return (
                <GenericSalesCard salesCTAText={salesCTAText} salesPhone={salesPhone}>
                    {coBrandedLogo && <img className="spectrum-logo" src={coBrandedLogo} alt="Partner logo" />}
                </GenericSalesCard>
            );
        case "xi6":
        case "xid":
        case "xg2v2":
            return (
                <GenericSalesCard salesCTAText={salesCTAText} salesPhone={salesPhone}>
                    <ComcastCode />
                </GenericSalesCard>
            );
        default: 
            return (<></>);
    }
};

export default SalesCard;